module.exports = __webpack_public_path__ + "img/sr.b644913b.svg";